import { useEffect, useState } from 'react';

/** Matches calendar_v3 mobile CSS breakpoint — full horizontal scroll, no sticky gutter. */
export const TEAM_CAL_MOBILE_MAX_WIDTH_PX = 640;

export function useTeamCalMobileLayout() {
  const [isMobileLayout, setIsMobileLayout] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${TEAM_CAL_MOBILE_MAX_WIDTH_PX}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia(`(max-width: ${TEAM_CAL_MOBILE_MAX_WIDTH_PX}px)`);
    const onChange = (event) => setIsMobileLayout(event.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobileLayout;
}
